import { typedAction } from "../../../helpers/redux.helper";
import {
  SET_LOGGED_IN,
  SET_USER_INFO,
  SET_LOGO_NON_LOGIN,
  SET_CUSTOMER_PORTAL,
  SET_SHOW_ROUTE,
  } from './user.constant';

export const setLoggedIn = (status: boolean) => {
  return typedAction(SET_LOGGED_IN, status);
};

export const setUserInfo = (data: any) => {
  return typedAction(SET_USER_INFO, data);
};

export const setLogoNonLogin = (data: any) => {
  return typedAction(SET_LOGO_NON_LOGIN, data)
}

export const setCustomerPortal = (customerPortal: boolean) => {
  return typedAction(SET_CUSTOMER_PORTAL, customerPortal)
}

export const setIsShowRoute = (isShowRoute: boolean) => {
  return typedAction(SET_SHOW_ROUTE, isShowRoute)
}